export const endpoints = {
  bulkUpsertContact: () => '/dashboard/contacts/bulk-upsert',
  listContacts: () => '/dashboard/contacts/list',
  contacts: () => '/dashboard/contacts',
  listTags: () => '/dashboard/tags',
  selectAll: () => '/dashboard/contacts/select-all',
  selectAllTags: () => '/dashboard/tags/select-all',
  contactAddTags: () => '/dashboard/contacts/add-tags',
  updateTagContacts: id => `/dashboard/tags/${id}/update-contacts`,
  contactRemoveTags: () => '/dashboard/contacts/remove-tags',
  tagDetail: id => `/dashboard/tags/${id}`,
  contactDetail: id => `/dashboard/contacts/${id}`
};
